require("!!/src/node_modules/script-loader/addScript.js")(require("!!/src/node_modules/raw-loader/index.js!/src/node_modules/foundation-sites/dist/js/foundation.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/foundation-sites/dist/js/foundation.js
// module id = 1894
// module chunks = 2